import { z } from "zod";
import { zDiaCivil, zId } from "./dominio.js";
import { zOfensiva } from "./ofensiva.js";
/**
 * O painel da home (tela 1 do SPEC).
 *
 * Uma resposta só, com tudo que a tela precisa. Não é economia de rede: é que
 * o dia, a meta, a ofensiva e o heatmap são leituras do **mesmo** instante, e
 * buscá-los em requisições separadas deixaria a tela mostrar um dia na faixa de
 * métricas e outro no heatmap na virada da meia-noite.
 */
export const zDiaDoHeatmap = z.object({
    data: zDiaCivil,
    respondidos: z.number().int(),
    acertos: z.number().int(),
    cumpriu: z.boolean(),
    ferias: z.boolean(),
});
export const zDosagemDoDia = z.object({
    categoriaId: zId,
    categoria: z.array(z.string()),
    alvoDiario: z.number().int().positive(),
    feitosHoje: z.number().int().nonnegative(),
});
export const zPainelDaHome = z.object({
    hoje: zDiaCivil,
    /** O dia de hoje, do jeito que o diário o registrou. */
    respondidosHoje: z.number().int(),
    acertosHoje: z.number().int(),
    metaDiaria: z.number().int().positive(),
    cumpriuHoje: z.boolean(),
    ofensiva: zOfensiva,
    /** Um ano de dias, só os que têm registro. Dia ausente é dia sem estudo. */
    heatmap: z.array(zDiaDoHeatmap),
    /** O primeiro dia da faixa do heatmap, para a grade saber onde começar. */
    heatmapDe: zDiaCivil,
    /**
     * Os dias de descanso da trilha (RN-17), para a grade marcar a célula.
     *
     * Vem no painel, e não em cada dia do heatmap, porque **dia de descanso sem
     * estudo não tem linha no diário**: a marca é função da data, não da linha.
     */
    diasDeDescanso: z.array(z.number().int().min(0).max(6)),
    /** Contagem regressiva da data-alvo da trilha (RN-20). `null` sem data-alvo. */
    diasAteAlvo: z.number().int().nullable(),
    dataAlvo: zDiaCivil.nullable(),
    /** Progresso no acervo: quantos itens já foram respondidos ao menos uma vez. */
    itensTotal: z.number().int(),
    itensVistos: z.number().int(),
    /** Quantos itens esperam por você agora. Vira atalho na tela. */
    erradasPendentes: z.number().int(),
    /**
     * Quantas revisões a fila do dia vai mostrar — já com o teto da trilha
     * aplicado (Fase 5). Ele dizia 173 enquanto a tela de revisar mostrava 30, e
     * um atalho que promete um trabalho que a tela seguinte não entrega é pior do
     * que um atalho sem número.
     */
    vencemHoje: z.number().int(),
    /** O total vencido, sem teto — para a tela poder dizer que há mais esperando. */
    vencidasAoTodo: z.number().int(),
    /** Dosagem por categoria (RN-19). Vazia quando a trilha não define nenhuma. */
    dosagem: z.array(zDosagemDoDia),
    emFerias: z.boolean(),
    feriasDesde: zDiaCivil.nullable(),
});
export const zFeriasEntrada = z.object({ ativo: z.boolean() });
export const zDosagemEntrada = z.object({
    /** A lista inteira: enviar vazio apaga a dosagem da trilha. */
    itens: z.array(z.object({ categoriaId: zId, alvoDiario: z.number().int().positive() })),
});
//# sourceMappingURL=home.js.map